import { render, staticRenderFns } from "./OrderTransferCode.vue?vue&type=template&id=08889302"
import script from "./OrderTransferCode.vue?vue&type=script&lang=js"
export * from "./OrderTransferCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports